// extracted by mini-css-extract-plugin
export default {"paneContent":"paneContent---Ljp8s","logsList":"logsList---IXMru"};